<template>
    <div class='post-price-offer-project-action'>
        <div v-if="project.status == 'project-created'">
            <button @click="showModal = true"
                    type="button"
                    class="button is-primary">Afklar projekt</button>

            <b-modal :active="showModal"
                     :canCancel="['escape']">
                <div class="modal-card"
                     style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Projekt afklaring</p>
                    </header>

                    <section class="modal-card-body">
                        <p>
                            Når du sætter projektet i afklaring, bliver der sendt en mail til kunden om, at du kigger på
                            opgaven
                            for at vurdere om du har tiden og de rettet kompetencer til opgaven.</p>
                        <br />
                        <p>
                            Denne vurdering bør højest tage 2 dage, inden du vender tilbage til kunden med enten et tilbud,
                            eller bede om flere informationer om opgaven for at vurdere projektet, eller annullere opgaven
                            😊
                        </p>

                    </section>

                    <footer class="modal-card-foot content-pulled-right">
                        <button class="button"
                                @click="showModal = false"
                                type="button">{{ $t('global.actions.back') }}</button>

                        <button class="button is-primary"
                                :class="{ 'is-loading': isSubmitting }"
                                @click="submitClarification"
                                :disabled="veeErrors.any()">Godkend afklaring</button>
                    </footer>
                </div>
            </b-modal>
        </div>
        <div v-else>
            <button v-if="project.offered_price"
                    @click="showModal = true"
                    type="button"
                    class="button is-info">Opdater tilbud</button>

            <button v-else
                    @click="showModal = true"
                    type="button"
                    class="button is-primary">Afgiv tilbud</button>

            <b-modal :active="showModal"
                     :canCancel="['escape']">
                <div class="modal-card"
                     style="width: auto">
                    <header class="modal-card-head">
                        <p class="modal-card-title">Afgiv tilbud</p>
                    </header>

                    <section class="modal-card-body">
                        <p>Når du afgiver dit tilbud, kan du sætte en lavere eller højere pris, men vi anbefaler at du læner
                            dig op af den vejledende pris, hvis du ikke er sikker på hvad du skal skrive.</p>
                        <br>
                        <p>Tilbuddet er bindende efter kundens accept. Indtil da har du mulighed for at tilrette både pris
                            og evt anslået timetal.</p>
                        <p>Når du afgiver et tilbud, får i begge en email og Taskflex får også besked.</p>
                        <br>

                        <div class="columns">
                            <div class="column is-6 is-12-touch">
                                <div class="box has-background-white-bis">
                                    <p class="has-text-weight-bold">Tilbudsberegner</p>

                                    <p>Den vejledende pris er: <strong>{{ project.starting_price }} kr. {{
                                        project.price_type
                                        === 'unit' ? 'for hele opgaven' : 'pr. time' }}</strong></p>
                                    <br>

                                    <p v-if="project.price_type === 'unit'">Husk at denne opgave er en opgave med en
                                        <strong>samlet pris</strong>, prisen du indtaster er derfor <strong>det endelige
                                            beløb</strong>.
                                    </p>
                                    <p v-else>Husk at denne opgave er en opgave med en <strong>timebaseret pris</strong>,
                                        prisen du indtaster er derfor <strong>prisen per time</strong>.</p>
                                    <br>

                                    <p class="label">Dit tilbud</p>
                                    <b-field :type="{ 'is-danger': veeErrors.has('offer') }"
                                             :message="veeErrors.first('offer')">
                                        <b-input v-model="offer"
                                                 type="number"
                                                 name="offer"
                                                 v-validate="'required|numeric|min_value:0'"
                                                 :data-vv-as="'Tilbuddet'">
                                        </b-input>
                                        <p class="control">
                                            <span class="button is-static">kr.</span>
                                        </p>

                                    </b-field>

                                    <template v-if="project.price_type !== 'unit'">
                                        <p>fordelt på</p>

                                        <b-field :type="{ 'is-danger': veeErrors.has('hours') }"
                                                 :message="veeErrors.first('hours')">
                                            <b-input v-model="hours"
                                                     type="number"
                                                     name="hours"
                                                     v-validate="'required|numeric|min_value:1'"
                                                     :data-vv-as="'Timetallet'">
                                            </b-input>
                                            <p class="control">
                                                <span class="button is-static">{{ hours === 1 ? 'time' : 'timer' }}</span>
                                            </p>

                                        </b-field>
                                    </template>
                                    <p>Prisen som vises til kunden er:
                                        <strong v-if="project.price_type === 'unit'">{{ offer }} kr. for hele
                                            opgaven</strong>
                                        <strong v-else>{{ offer * hours }} kr. i alt ({{ hours }} {{ hours === 1 ? 'time' :
                                            'timer' }} á {{ offer }} kr.)</strong>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </section>

                    <footer class="modal-card-foot content-pulled-right">
                        <button class="button"
                                @click="showModal = false"
                                type="button">{{ $t('global.actions.back') }}</button>

                        <button class="button is-primary"
                                :class="{ 'is-loading': isSubmitting }"
                                @click="submit"
                                :disabled="veeErrors.any()">Indsend tilbud</button>
                    </footer>
                </div>
            </b-modal>
        </div>
    </div>
</template>


<script>
import ProjectService from '@/taskflex/projects/services/ProjectService';

export default {
    data() {
        return {
            showModal: false,
            isSubmitting: false,
            offer: null,
            hours: 1,
        };
    },

    props: {
        project: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        this.offer = this.project.offered_price || this.project.starting_price;

        if (this.project.price_type !== 'unit') {
            this.hours = this.project.hours_used;
        }
    },

    methods: {
        async submitClarification() {
            this.isSubmitting = true;

            const options = {};

            ProjectService.postProjectClarification(this.project.id, options, ({ data }) => {
                this.isSubmitting = false;
                this.showModal = false;

                this.$emit('posted', data);
            });
        },
        async submit() {
            if (!await this.$validator.validateAll()) {
                return;
            }

            const options = {
                offer: this.offer,
            };

            if (this.project.price_type !== 'unit') {
                options.hours = this.hours;
            }

            this.isSubmitting = true;

            ProjectService.postPriceOffer(this.project.id, options, ({ data }) => {
                this.isSubmitting = false;
                this.showModal = false;

                this.$emit('posted', data);
            });
        },
    },
};
</script>




// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectActions/PostPriceOfferProjectAction.vue